module.exports = __webpack_public_path__ + "front/img/edm-agenda.2ec77d34.png";